export const duration = 200;

export const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: '0px'
};

export const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
  unmounted: { opacity: 0 }
};
